import React, { forwardRef, useImperativeHandle, useState } from 'react'

import {
  Botao,
  FormUnform,
  InputUnform,
  ModalBase,
  Spacer
} from 'src/componentes'

import { createSchema } from './schema'
import { ContainerBotoes, Corpo } from './styles'
import {
  ModalVincularDisciplinaModuloProps,
  ModalVincularDisciplinaModuloRef
} from './tipos'

const ModalVincularDisciplina: React.ForwardRefRenderFunction<
  ModalVincularDisciplinaModuloRef,
  ModalVincularDisciplinaModuloProps
> = ({ backdrop, acaoPrimaria, acaoSecundaria, titulo }, ref) => {
  const [aberta, definirAberta] = useState(false)
  const [pronto, definirPronto] = useState(false)

  const fechar = () => {
    definirPronto(false)
    definirAberta(false)
  }

  const abrir = () => {
    definirPronto(true)
    definirAberta(true)
  }

  useImperativeHandle<
    ModalVincularDisciplinaModuloRef,
    ModalVincularDisciplinaModuloRef
  >(ref, () => ({
    fechar,
    abrir
  }))

  const acaoSucesso = async (dados: any) => {
    acaoPrimaria(dados)
    fechar()
  }

  return (
    <ModalBase aberta={aberta} backdrop={backdrop}>
      <Corpo style={{ width: '500px' }}>
        <h5> {titulo} </h5>
        <Spacer padding="10px 0px" />
        {pronto && (
          <FormUnform acaoSucesso={acaoSucesso} schema={createSchema}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '15px'
              }}
            >
              <div style={{ width: '100%' }}>
                <InputUnform
                  name="nome"
                  label="Nome da Disciplina"
                  obrigatorio
                  maxLength={200}
                />
                <InputUnform
                  name="cargaHoraria"
                  label="Carga Horária"
                  obrigatorio
                  maxLength={200}
                />
              </div>
            </div>
            <Spacer padding="20px 0px" />
            <ContainerBotoes>
              <Botao
                type="button"
                id="btn-cancelar"
                texto="Cancelar"
                tema="Secundario"
                onClick={() => {
                  acaoSecundaria && acaoSecundaria()
                  fechar()
                }}
              />
              <Botao type="submit" id="btn-salvar" texto="Vincular" />
            </ContainerBotoes>
          </FormUnform>
        )}
      </Corpo>
    </ModalBase>
  )
}

export const ModalVincularDisciplinaModulo = forwardRef(ModalVincularDisciplina)
